import { render, staticRenderFns } from "./PressureTap.vue?vue&type=template&id=87f45f82&scoped=true&"
import script from "./PressureTap.vue?vue&type=script&lang=js&"
export * from "./PressureTap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87f45f82",
  null
  
)

export default component.exports